import React from "react";
import "./Bonus_Card.css";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Bonus_Card({ bonusNo, amount, invites, deposits }) {
  return (
    <>
      <section className="Bonus_Card_holder">
        <div className="bg_holder">
          <img
            src="/assets/images/Invitation_Bonus/Bonus_Card/card_bg.png"
            className="bg_img"
            alt="bg"
          />
        </div>

        <div className="Bonus_Card">
          <div className="card_holder">
            <div className="bonus_header">
              <div className="left">
                <span className="bonus_label">Bonus</span>
                <span className="bonus_no">{bonusNo}</span>
                <span className="bonus_no">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
              </div>

              <div className="amount  me-3">₹{amount}</div>
            </div>

            <div className="bonus_body">
              <div className="bonus_body_holder">
                <span>Number of invites</span>
                <span>1</span>
              </div>

              <div className="bonus_body_holder">
                <span>Recharge per people</span>
                <span className="red">₹55.00</span>
              </div>
            </div>

            <div className="bonus_footer">
              <div>
                <strong className="amount">{invites}</strong>
                <p>Number of invites</p>
              </div>

              <div>
                <strong className="red">{deposits}</strong>
                <p>Deposit Number</p>
              </div>
            </div>
            <div className="text-center">
              <button className="received_btn">Received</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Bonus_Card;
